/**
 * Modal filho para cadastro rápido de cliente (emissão fiscal / vendas).
 */

import { useState, useEffect } from 'react'
import { UserPlus, Loader2 } from 'lucide-react'
import ModalERP from '../../ModalERP'
import { customerService } from '../../../../services/erpApi'
import { formatCpfCnpj } from '../../../../utils/cpfUtils'
import './CadastroRapidoClienteModal.css'

function CadastroRapidoClienteModal({ isOpen, onClose, onSuccess }) {
  const [form, setForm] = useState({ name: '', cpfCnpj: '', email: '', phone: '' })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!isOpen) {
      setForm({ name: '', cpfCnpj: '', email: '', phone: '' })
      setError(null)
      setLoading(false)
    }
  }, [isOpen])

  const handleSubmit = async () => {
    if (!form.name.trim()) {
      setError('Nome é obrigatório')
      return
    }
    if (!form.cpfCnpj.trim()) {
      setError('CPF/CNPJ é obrigatório')
      return
    }

    setLoading(true)
    setError(null)
    try {
      const res = await customerService.createQuick({
        name: form.name.trim(),
        cpfCnpj: form.cpfCnpj.replace(/\D/g, ''),
        email: form.email.trim() || null,
        phone: form.phone.trim() || null
      })

      if (res.success && res.data) {
        onSuccess?.(res.data)
        onClose()
      } else {
        setError(res.message || 'Erro ao cadastrar cliente')
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Erro ao cadastrar cliente')
    } finally {
      setLoading(false)
    }
  }

  return (
    <ModalERP
      isOpen={isOpen}
      onClose={onClose}
      title="Cadastro rápido de cliente"
      subtitle="Dados mínimos para emissão de NF-e"
      icon={<UserPlus size={22} />}
      size="md"
      layer={1}
      loading={loading}
      footer={
        <>
          <button
            type="button"
            className="modal-erp-btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="modal-erp-btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Loader2 size={16} className="modal-erp-spinner" />}
            Cadastrar
          </button>
        </>
      }
    >
      {error && <p className="cadastro-rapido-error">{error}</p>}

      <div className="cadastro-rapido-field">
        <label htmlFor="quick-customer-name">Nome *</label>
        <input
          id="quick-customer-name"
          type="text"
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          disabled={loading}
          autoFocus
        />
      </div>

      <div className="cadastro-rapido-field">
        <label htmlFor="quick-customer-doc">CPF/CNPJ *</label>
        <input
          id="quick-customer-doc"
          type="text"
          value={form.cpfCnpj}
          onChange={(e) => setForm((f) => ({ ...f, cpfCnpj: formatCpfCnpj(e.target.value) }))}
          disabled={loading}
        />
      </div>

      <div className="cadastro-rapido-field">
        <label htmlFor="quick-customer-email">E-mail</label>
        <input
          id="quick-customer-email"
          type="email"
          value={form.email}
          onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          disabled={loading}
        />
      </div>

      <div className="cadastro-rapido-field">
        <label htmlFor="quick-customer-phone">Telefone</label>
        <input
          id="quick-customer-phone"
          type="tel"
          value={form.phone}
          onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
          disabled={loading}
        />
      </div>
    </ModalERP>
  )
}

export default CadastroRapidoClienteModal
